<template>
  <div data-testid="icon-display" class="flex flex-row items-center gap-1">
    <component :is="props.iconComponent" class="h-7 w-7 flex-shrink-0" />
    <div
      class="capitalize text-xs font-normal leading-4 tracking-normal text-indigo-base"
    >
      {{ props.text }}<slot></slot>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  iconComponent: {
    type: [String, Object],
    required: true,
  },
  text: {
    type: String,
    default: "",
  },
});
</script>

<style scoped></style>
